<template>
<div class="tab_content">
  <v-row>
    <v-col sm="12" md="11" class="">
        <easyinput></easyinput>
      <div class="simple_search_box">
        <div class="box_title">使用帮助</div>
        <div class="box_list">
          <router-link to="/help" target="_blank">
            <div class="box_item">
              <div class="left_img"><img :src="img1" alt=""></div>
              <div class="right_text">
                <div class="title1">高级检索篇</div>
                <div class="desc1">被忽略的信息录入技巧</div>
                <div class="link1">了解一下 ></div>
              </div>
            </div>
          </router-link>
          <router-link to="/help" target="_blank">
            <div class="box_item">
              <div class="left_img"><img :src="img2" alt=""></div>
              <div class="right_text">
                <div class="title1">高级检索篇</div>
                <div class="desc1">简易精准的逻辑运算</div>
                <div class="link1">了解一下 ></div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </v-col>
  </v-row>
</div>
</template>

<script>
import {getPnc} from "../../../../assets/js/methods";
import easyinput from '../commponts/easyinput.vue';


export default {
  components: { easyinput },
  name: "easySearch",
  data() {
    return {
      model: "",
      borActive: false,
      items:[],
      search: "",
      history1: [],
      img1:require("@/assets/images/icons/help_img1.svg"),
      img2:require("@/assets/images/icons/help_img3.svg"),
      rspnation:
          "cn;;;jp;;;us;;;kr;;;wo;;;de;;;gb;;;fr;;;ca;;;tw;;;au;;;es;;;ru;;;zn;;;at;;;it;;;in;;;br;;;eu;;;se;;;no;;;ch;;;fi;;;dk;;;pl;;;mx;;;nl;;;be;;;il;;;hk;;;za;;;my;;;hu;;;pt;;;ar;;;ua;;;cz;;;id;;;nz;;;sg;;;gr;;;ro;;;ea;;;ie;;;tr;;;cl;;;sh;;;vn;;;ph;;;si;;;pe;;;bg;;;hr;;;sk;;;co;;;lu;;;ap;;;uy;;;cy;;;rs;;;md;;;th;;;tn;;;ec;;;lt;;;eg;;;oa;;;ma;;;mn;;;mo;;;cr;;;lv;;;ee;;;gt;;;is;;;cu;;;mc;;;ge;;;do;;;jo;;;pa;;;sa;;;gc;;;sm;;;me;;;sv;;;ni;;;zw;;;hn;;;bn;;;zm;;;dz;;;mt;;;bh;;;py;;;ke;;;mw;;;ve;;;tj;;;ae;;;bo;;;ba;;;kz;;;bd;;;iq;;;by;;;la;;;kh;;;sy;;;uz;;;az;;;mk;;;tm;;;am;;;kg;;;tt",
      types: [],
      cList:[],
      dialog: false,
      typeList:[],
      isAllCountry: false,
      isIndeter1: false,
      selectedCountry: [],
      multiple: false,
      country: [],
      list: [],

    }
  },
  watch: {
    isAllCountry(val) {
      if (val) {
        this.country = this.list;
      } else {
        this.country = [];
      }
    },
  },
  methods: {
    goResult() {

      if (!this.model && !this.inputKey) {
        this.$message({
          type: "info",
          message: "请输入关键词",
        });
        return false;
      }
      this.$router.push({
        path: "/search/result",
        query: {
          str: this.model || this.inputKey,
        },
      });
      this.setSearchType(0)
      this.setSearchKey(this.model || this.inputKey)
    },
    //
    getCountrys() {
      let list = this.rspnation.split(";;;");
      this.list = list;
      console.log(this.list)
      list.forEach((item) => {
        let c = {
          name: getPnc(item),
          code: item,
        };
        this.cList.push(c);
      });
    },
    openCountry() {
      this.dialog = true;
      this.getCountrys();
      let country = localStorage.getItem("countries");
      if (country) {
        this.country = JSON.parse(country);
      } else {
        this.country = ['cn'];
      }
      let types = localStorage.getItem("types");
      if (types) {
        this.types = JSON.parse(types);
      } else {
        this.types = [];
      }
    },
    saveCountry() {
      let country = JSON.stringify(this.country);
      localStorage.setItem("countries", country);
      let types = JSON.stringify(this.types);
      localStorage.setItem("types", types);
      this.dialog = false;
    },
    goHistory() {
      this.$router.push({
        path: '/user/history'
      })
    }
  },

}
</script>

<style scoped>

</style>